__turbopack_context__.v({
  "blink": "DotLoader-module-scss-module__sxnDgq__blink",
  "circle": "DotLoader-module-scss-module__sxnDgq__circle",
  "dot": "DotLoader-module-scss-module__sxnDgq__dot",
  "loader": "DotLoader-module-scss-module__sxnDgq__loader",
  "spinner": "DotLoader-module-scss-module__sxnDgq__spinner",
});
